export default {
  agreement: {
    listTitle: 'Agreement List',
    userAgreement: 'User Agreement',
    privacyAgreement: 'Privacy Agreement',
    cancellationAgreement: 'Account Cancellation Agreement',
    configured: 'Configured',
    notConfigured: 'Not Configured',
    effectiveChannels: 'Effective Channels',
    updateTime: 'Updated At',
    updatedBy: 'Updated By',
    wechatMiniProgram: 'WeChat Mini Program',
    alipayMiniProgram: 'Alipay Mini Program',
    app: 'APP',
    content: 'Agreement Content',
    contentRequired: 'Enter the agreement content',
    contentLimit: 'Agreement content cannot exceed {count} characters',
    saveTip: 'After saving, this content will take effect on the agreement pages of the corresponding channels.',
    saveSuccess: 'Agreement saved successfully',
    unsavedTitle: 'Unsaved Changes',
    unsavedMessage: 'Switching agreements or leaving this page will discard the unsaved changes to the current agreement.',
    continueEditing: 'Continue Editing',
    discardChanges: 'Discard Changes',
    empty: 'No agreement data',
  },
};
